var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldGallerySlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.679 2.229-18.45 18.46c-.3.3-.3.79 0 1.09a.758.758 0 0 0 1.08-.01l18.46-18.46c.31-.3.31-.78 0-1.08-.3-.3-.79-.3-1.09 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.001 10.381a2.38 2.38 0 1 1 0-4.76 2.38 2.38 0 0 1 0 4.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.388 6.61c.08.37.11.77.11 1.2v4.8l-.13-.11c-.78-.67-2.04-.67-2.82 0l-4.16 3.57c-.71.61-1.83.67-2.61.15l-5.38 5.38c.04.02.08.03.12.04.27.09.54.16.83.22.1.02.2.04.31.05.37.05.75.09 1.15.09h8.38c3.64 0 5.81-2.17 5.81-5.81V7.81c0-.9-.13-1.71-.39-2.42l-1.22 1.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 6.61c.08.37.11.77.11 1.2v4.8l-.13-.11c-.78-.67-2.04-.67-2.82 0l-4.16 3.57c-.71.61-1.83.67-2.61.15l-5.39 5.39c.71.26 1.52.39 2.42.39h8.38c3.64 0 5.81-2.17 5.81-5.81V7.81c0-.9-.13-1.71-.39-2.42l-1.22 1.22zM19.4 4.6c-.72-.73-1.8-1.1-3.21-1.1H7.81C4.99 3.5 3.5 4.99 3.5 7.81v8.38c0 .76.13 1.41.35 1.97l3.74-2.51c.34-.23.73-.35 1.12-.36l-5.17 5.17c-.4-.4-.73-.88-.98-1.43-.37-.8-.56-1.75-.56-2.84V7.81C2 4.17 4.17 2 7.81 2h8.38c1.82 0 3.27.54 4.27 1.54L19.4 4.6z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGallerySlash);
export default __webpack_public_path__ + "static/media/vuesax-bold-gallery-slash.9da3ac6d75ce5cdee39ae34e33485a11.svg";
export { ForwardRef as ReactComponent };